import * as openpgp from "openpgp";
import { readFileFromBase64 } from "./readFileFromBase64";
import { readAsBase64 } from "./readAsBase64";

export interface ISingleBinaryKeys {
  PublicKey: string;
  PrivateKey: string;
  cleanPublicKey: openpgp.key.KeyResult;
  cleanPrivateKey: openpgp.key.KeyResult;
}

export const generateEncryptedKey = async (
  pubKeysBase64?: string[],
): Promise<ISingleBinaryKeys> => {
  let encryptKey: openpgp.key.Key[] = [];

  if (pubKeysBase64) {
    encryptKey = await Promise.all(
      pubKeysBase64?.map(async (k) => {
        var keyBuffer = await readFileFromBase64(k, "application/other");

        try {
          const armored = new TextDecoder().decode(keyBuffer);
          var key = await openpgp.key.readArmored(armored);

          if (key.keys.length) return key.keys[0];
        } catch {
          console.error("Failed to decode key");
        }

        const notArmoredKey = await openpgp.key.read(new Uint8Array(keyBuffer));
        return notArmoredKey.keys[0];
      }),
    );
  }

  if (!encryptKey)
    throw new Error(
      "Something was wrong with creatiing new keys missing encryption key",
    );

  console.log("Receiver keys", pubKeysBase64, encryptKey);

  let options: openpgp.KeyOptions = {
    userIds: [
      {
        name: "1",
      },
    ],
    curve: "secp256k1",
    numBits: 2048,
  };

  const key = await openpgp.generateKey(options);
  const pubDecoded = await openpgp.key.readArmored(key.publicKeyArmored);
  const privDecoded = await openpgp.key.readArmored(key.privateKeyArmored);
  const publicKeyResultString = new Uint8Array(
    pubDecoded.keys[0].toPacketlist().write(),
  );
  const keyResultString = new Uint8Array(
    privDecoded.keys[0].toPacketlist().write(),
  );
  const { message } = await openpgp.encrypt({
    message: await openpgp.message.fromBinary(keyResultString),
    publicKeys: encryptKey,
    armor: false,
  });

  return {
    PublicKey: await readAsBase64(publicKeyResultString),
    PrivateKey: await readAsBase64(new Uint8Array(message.packets.write())),
    cleanPublicKey: pubDecoded,
    cleanPrivateKey: privDecoded,
  };
};
